import { render, staticRenderFns } from "./NotificationManagement.vue?vue&type=template&id=1e65cd9a&scoped=true"
import script from "./NotificationManagement.vue?vue&type=script&lang=js"
export * from "./NotificationManagement.vue?vue&type=script&lang=js"
import style0 from "./NotificationManagement.vue?vue&type=style&index=0&id=1e65cd9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e65cd9a",
  null
  
)

export default component.exports